import ProductConfigModel from '../models/ProductConfigModel';
import { stitchDefaults } from './defaults';

export default {
    ...stitchDefaults,
    pathTemplate: 'bdfed/gameday/{locale:en-US}?gamePk={gamePk}&config=true&appContext={appContext}&stitch_env={stitchEnv}',
    expires: false,
    model: ProductConfigModel
};
